import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IAddressRestsService } from "./address-rests";
import { Address } from "@modules/user/model/domain/address/Address";
import { AddressBook } from "@modules/user/model/domain/address/address-book";
import is from "@core/comparators/is";
import { ICustomsClearanceInfo } from "@modules/clearance/model/clearance-info";

type responseAddress = Address & Array<ICustomsClearanceInfo>;

export class AddressRestsService extends AbstractAccessorService<Address> implements IAddressRestsService {
    public readonly $name: string = "AddressRestsService";

    public static readonly $inject: string[] = ["$accessor", "$q"];
    // Partner默认地址缓存
    private defaultAddressCache: Map<string, Address>;

    constructor(public $accessor: IDataAccessor<Address>, public $q: angular.IQService) {
        super();
        this.defaultAddressCache = new Map();
    }

    /**
     * @description 获取地址簿列表
     */
    public getAddress(): angular.IPromise<IResponse<Array<Address>>> {
        return this.$accessor<Array<Address>, {}, string>(this.$name, "getAddress");
    }
    /**
     * @description 获取默认地址簿
     */
    public getDefaultAddress(partnerId?: number): angular.IPromise<IResponse<responseAddress>> {
        const defer = this.$q.defer<IResponse<responseAddress>>();
        if (!is.undefined(partnerId) && this.defaultAddressCache.has(String(partnerId))) {
            defer.resolve({
                success: true,
                data: (this.defaultAddressCache.get(String(partnerId)) as responseAddress)
            });
        } else {
            this.$accessor<responseAddress, {}, string>(this.$name, "getDefaultAddress")
                .then((addressResp) => {
                    if ((addressResp.Success || addressResp.success) && addressResp.data) {
                        const partnerIdStr = String(addressResp.data.partnerId);
                        this.defaultAddressCache.set(partnerIdStr, addressResp.data);
                    }
                    defer.resolve(addressResp);
                }, error => {
                    defer.reject(error);
                })
        }

        return defer.promise;
    }
    /**
     * @description 查询指定ID的地址簿
     */
    public search(addressBookId: number): angular.IPromise<IResponse<Address>> {
        return this.$accessor<Address, { addressBookId: number }, string>(this.$name, "search", {
            parameter: {
                addressBookId: addressBookId
            }
        });
    }
    /**
     * @description 校验地址
     */
    public checkAddress(address: AddressBook): angular.IPromise<IResponse<void>> {
        return this.$accessor<void, {}, string>(this.$name, "checkAddress", {
            data: address
        });
    }

}